module.exports = "/img/ok-form.svg?617159beda650bf528ef9f2c55d2bd21";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/ok-form.svg
// module id = Qmcp
// module chunks = 44